export default __webpack_public_path__ + "static/media/installation-design.aa9b1e31.png";